// 메트로놈 아이콘 (MUI 아이콘 세트에 없어 직접 그림)
import React from 'react';
import { SvgIcon } from '@mui/material';

export default function MetronomeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9.2 3h5.6l4.2 17.5H5L9.2 3Z" />
        <path d="M7.4 15.5h9.2" />
        <path d="M12 15.5 17.2 5.5" />
      </g>
      <circle cx="15" cy="9.7" r="1.5" />
    </SvgIcon>
  );
}
